import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { DialogComponent } from './dialogComponent.js';
import { DialogTitle } from './DialogTitle.js';
import { DialogFooter } from './DialogFooter.js';
import { DialogBody } from './DialogBody.js';

var Dialog = function Dialog(_a) {
  var _b = _a.boxShadow,
      boxShadow = _b === void 0 ? true : _b,
      visible = _a.visible,
      id = _a.id,
      children = _a.children,
      _c = _a.onCloseClick,
      onCloseClick = _c === void 0 ? function () {
    return undefined;
  } : _c,
      _d = _a.fixed,
      fixed = _d === void 0 ? true : _d,
      fcStyle = _a.fcStyle,
      _e = _a.showOverlay,
      showOverlay = _e === void 0 ? true : _e,
      focusElement = _a.focusElement,
      rest = __rest(_a, ["boxShadow", "visible", "id", "children", "onCloseClick", "fixed", "fcStyle", "showOverlay", "focusElement"]);

  var dialogProps = {
    boxShadow: boxShadow,
    onCloseClick: onCloseClick,
    fixed: fixed,
    fcStyle: fcStyle,
    id: id,
    showOverlay: showOverlay,
    visible: visible,
    focusElement: focusElement
  };

  if (!fixed) {
    return /*#__PURE__*/React.createElement(DialogComponent, __assign({
      focusElement: null
    }, dialogProps, rest), children);
  }

  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement(DialogComponent, __assign({
    focusElement: focusElement
  }, dialogProps, rest), children)), document.body);
};

Dialog.Title = DialogTitle;
Dialog.Footer = DialogFooter;
Dialog.Body = DialogBody;
export default Dialog;
export { Dialog };